import { render, staticRenderFns } from "./ScreenOrders.vue?vue&type=template&id=44b75266&scoped=true"
import script from "./ScreenOrders.vue?vue&type=script&lang=js"
export * from "./ScreenOrders.vue?vue&type=script&lang=js"
import style0 from "./ScreenOrders.vue?vue&type=style&index=0&id=44b75266&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b75266",
  null
  
)

export default component.exports